__turbopack_context__.v({
  "dark": "PlusDividerBlock-module__CjTXxq__dark",
  "divider": "PlusDividerBlock-module__CjTXxq__divider",
  "left": "PlusDividerBlock-module__CjTXxq__left",
  "light": "PlusDividerBlock-module__CjTXxq__light",
  "primary": "PlusDividerBlock-module__CjTXxq__primary",
  "right": "PlusDividerBlock-module__CjTXxq__right",
  "secondary": "PlusDividerBlock-module__CjTXxq__secondary",
});
